// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function SignatureIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M29 21H7.983c.332-.655.666-1.329 1-2.014 1.866.206 4.077-1.1 6.592-3.902.075.207.159.421.25.637.814 1.907 1.864 2.993 3.125 3.232 1.293.25 2.573-.404 3.885-1.978C23.687 17.984 25.437 19 29 19a1 1 0 0 0 0-2c-3.829 0-4.944-1.324-5-2.027a1 1 0 0 0-1.939-.318c-1.521 2.281-2.422 2.393-2.75 2.333-1.041-.197-2.01-2.617-2.336-4.19a1 1 0 0 0-1.85-.278c-2.475 3.078-4.135 4.125-5.176 4.393 1.061-2.36 1.854-4.432 2.361-6.175.852-2.93.915-4.98.189-6.263-.375-.67-1.162-1.469-2.739-1.475h-.031c-2 .014-3.575 1.912-4.328 5.213-.449 1.963-.522 4.148-.204 6 .32 1.85.983 3.188 1.944 3.986-.465.966-.941 1.91-1.404 2.803H3a1 1 0 0 0 0 2h1.676c-1.415 2.626-2.515 4.456-2.532 4.486a1 1 0 1 0 1.713 1.03c.02-.033 1.41-2.35 3.088-5.515H29a1 1 0 0 0 0-2V21Zm-5-6v-.026V15ZM7.349 8.658C7.847 6.473 8.81 5 9.75 5c.656 0 .875.232 1 .459.375.666.815 3.024-2.706 10.796-1.024-1.411-1.373-4.63-.695-7.597Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
